import React from 'react';
import styled from 'styled-components';
import {
  HeadlineOne,
  HeadlineTwo,
  Paragraph,
  WrapperCenter,
} from 'components/atoms/SectionWrapper.style';

const FarmDesc = () => (
  <>
    <WrapperCenter>
      <HeadlineOne>OFERTA ELGREEN: PROJEKTOWANIE</HeadlineOne>
      <Paragraph>
        Firma Elgreen zajmuje się projektowaniem instalacji elektrycznych i
        niskoprądowych, DSO, SSP, SAP, kontroli dostępu w pełnym zakresie i dla
        wszystkich typów obiektów (również w technologii BIM). W zakres
        instalacji elektrycznych wchodzą wszelkie instalacje elektryczne i
        niskoprądowe wymagane dla obiektów typu: biurowego, handlowego,
        magazynowego, przemysłowego, mieszkaniowego, użyteczności publicznej,
        obiekty sportowe i służby zdrowia.
      </Paragraph>
      <Paragraph>
        Wykonujemy projekty sieci elektroenergetycznych nN, SN, WN, oświetlenia
        drogowego, usunięcia kolizji. Współpracujemy z ENERGĄ-Operator SA        {/* ENEĄ-OPERATOR SA */}
         dla których wykonujemy projekty sieci
        elektroenergetycznych (przyłącza, linie kablowe nN, SN, WN, stacje
        transformatorowe itp.).
      </Paragraph>

      <Paragraph>
        Wykonujemy projekty związane z OZE. Projektujemy zarówno farmy
        fotowoltaiczne, wiatrowe jak również rozwiązania skierowane do klientów
        biznesowych w celu optymalizacji zużycia energii elektrycznej oraz
        pozyskania jej z OZE w ich przedsiębiorstwach i zakładach produkcyjnych.
      </Paragraph>
      <Paragraph>
        Posiadamy wszelkie kwalifikacje do projektowania instalacji będących w
        zakresie naszej działalności. Dbamy o poszerzanie naszej wiedzy
        uczestnicząc w sympozjach dotyczących tematyki energetyki, oraz we
        wszelkich szkoleniach organizowanych przez producentów i wytwórców, a
        także stowarzyszenia branży elektrycznej.
      </Paragraph>
      <Paragraph>
        Przygotowane przez nas projekty opracowane są z pełną rzetelnością i
        profesjonalizmem, są zgodne z Polskimi Normami, aktualnymi przepisami i
        najnowszą wiedzą techniczną. Gwarantujemy ich jakość - są weryfikowane
        przez wysokiej klasy projektantów oraz posiadają wszelkie niezbędne
        uzgodnienia. Przygotowujemy pełne dokumentacje projektowe zawierające:
        projekty, przedmiary, kosztorysy.
      </Paragraph>
      <HeadlineTwo>ZAPRASZAMY DO WSPÓŁPRACY</HeadlineTwo>
    </WrapperCenter>
  </>
);

export default FarmDesc;
